import itemId from 'owa-service/lib/factory/itemId';
export default function createItemIdForRequest(id) {
    return id
        ? itemId({
            Id: id.Id,
            ChangeKey: id.ChangeKey,
        })
        : null;
}
//# sourceMappingURL=createItemIdForRequest.js.map